import React from 'react'

const PwdTick = ({ className = '' }) => (
  <svg
    className={className}
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      cx='5'
      cy='5'
      r='4.83333'
      fill='#CFF6E8'
      stroke='#0FD08B'
      strokeWidth='0.333333'
    />
    <path
      d='M3 4.99996L4.33333 6.33329L7 3.66663'
      stroke='#0FD08B'
      strokeWidth='0.666667'
      strokeMiterlimit='10'
      strokeLinecap='square'
    />
  </svg>
)

export default PwdTick
